import HttpService from '@/common/services/HttpService'
import type { SpaceDTOV1 } from '@/common/types/spaces'

export const getSpaces = async (): Promise<SpaceDTOV1[]> => {
  return HttpService.getData<SpaceDTOV1[]>('/api/v1/spaces')
}
